<template>
  <div
    class="container-wrapper"
    v-if="info"
    :style="
      'background-image: url(' + getBrandThemeURL('estimate/report/header_background.png') + ')'
    "
  >
    <div class="container">
      <!-- 报告信息 -->
      <ReportCard>
        <div class="report-infor" slot="content">
          <div class="report-infor-tips">*估分排名实时更新</div>

          <!-- 得分 -->
          <div class="report-infor-score">
            <div class="my-score">
              <span class="number">{{ info.score }}</span>
              <span class="text">分</span>
            </div>
            <div class="total-score">满分{{ info.total_score }}分</div>
          </div>
          <!-- 排名 -->
          <div class="report-infor-ranking">
            <div class="ranking-title">
              <img src="@/assets/images/estimate/report/icon_01.png" class="title-icon" />
              <p class="ranking-text">
                <img src="@/assets/images/estimate/report/icon_trophy.png" class="trophy-icon" />
                <span class="text">总排名:</span>
                <span class="text2 text-color-main">{{ info.ranking }}</span>
                <span class="text2">/</span>
                <span class="text2">{{ info.total_ranking }}</span>
              </p>
              <img src="@/assets/images/estimate/report/icon_01.png" class="title-icon" />
            </div>

            <div class="ranking-score">
              <div class="ranking-score-item">
                <p class="number">{{ distribution_map.max_score }}</p>
                <p class="text">最高分</p>
              </div>
              <div class="ranking-score-item">
                <p class="number">{{ distribution_map.avg_score }}</p>
                <p class="text">平均分</p>
              </div>
              <div class="ranking-score-item">
                <p class="number number--beat">{{ distribution_map.percentage }}%</p>
                <p class="text">击败考生</p>
              </div>
            </div>
          </div>
          <!-- 试卷信息 -->
          <div class="report-infor-questionset">
            <van-cell title="估分试卷：" :value="paper_info.name" :border="false" />
            <van-cell title="估分时间：" :value="paper_info.submited_time" :border="false" />
          </div>
        </div>
      </ReportCard>
      <!-- 报告信息 -->
      <ReportCard title="同岗位估分情况" v-if="rec_job_info">
        <div class="report-job" slot="content">
          <!-- 估分岗位 -->
          <template v-if="volunt_record.length > 1">
            <div class="tab-nav">
              <div
                class="tab-nav-item"
                :class="{ active: tabNavIndex === index }"
                v-for="(item, index) in volunt_record"
                :key="index"
                @click="tabNavIndex = index"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="tab-content">
              <div class="report-job-list">
                <div class="tab-content-item" v-for="(record, index) in volunt_record" :key="index">
                  <template v-if="tabNavIndex === index">
                    <van-cell title="我的岗位排名：" :border="false">
                      <template #right-icon>
                        <div class="van-cell__value my-job-value">
                          <span class="text-color-main">
                            {{ record.ranking }}
                          </span>
                          /{{ record.total_ranking }}名
                        </div>
                      </template>
                    </van-cell>
                    <van-cell
                      :title="item.title + '：'"
                      :value="item.value"
                      :border="false"
                      v-for="(item, index) in record.list"
                      :key="index"
                    />
                  </template>
                </div>
              </div>
            </div>
          </template>
          <div class="report-job-list" v-else>
            <van-cell title="我的岗位排名：" :border="false">
              <template #right-icon>
                <div class="van-cell__value my-job-value">
                  <span class="text-color-main">
                    {{ rec_job_info.ranking }}
                  </span>
                  /{{ rec_job_info.total_ranking }}名
                </div>
              </template>
            </van-cell>
            <van-cell
              :title="item.title + '：'"
              :value="item.value"
              :border="false"
              v-for="(item, index) in rec_job_info.list"
              :key="index"
            />
          </div>
        </div>
      </ReportCard>
      <ReportCard title="试卷估分分布图" v-if="distribution_map">
        <div slot="content">
          <ReportLineChart
            :scoreArray="distribution_map.score_map"
            :questionsetScore="info.total_score"
            :myScore="info.score"
            style="margin-top: 0.27rem"
          />
        </div>
      </ReportCard>

      <ReportCard title="答题情况" v-if="point">
        <template #content>
          <div class="report-answer-infor">
            <div class="answer-summary">
              <div class="summary-item">
                <p class="name">一共</p>
                <p class="text">
                  <span class="font-number">{{ info.total_num }}</span>
                  题
                </p>
              </div>
              <div class="summary-item">
                <p class="name">答对</p>
                <p class="text">
                  <span class="font-number">{{ info.correct_num }}</span>
                  题
                </p>
              </div>
              <div class="summary-item">
                <p class="name">答错</p>
                <p class="text text--error">
                  <span class="font-number">{{ info.wrong_num }}</span>
                  题
                </p>
              </div>
              <div class="summary-item">
                <p class="name">未答</p>
                <p class="text text--empty">
                  <span class="font-number">{{ info.not_answer_num }}</span>
                  题
                </p>
              </div>
              <div class="summary-item">
                <p class="name">总用时</p>
                <p class="text">
                  <span class="font-number">{{ secondText(info.used_time) }}</span>
                </p>
              </div>
            </div>
          </div>
          <CollapseKnowledge :list="point" />
        </template>
      </ReportCard>

      <ReportCard v-if="answerSheetData.length">
        <template #content>
          <AnswerSheet :answer="answerSheetData" />
        </template>
      </ReportCard>
    </div>
    <FooterOpenApp
      ref="footer_open_app"
      :name="getCurrentBrand.name"
      :logoImage="getCurrentBrand.imageLogoURL"
      :replace_id="info.item_id"
      text="参与考试估分"
      :schemaUnitKey="schemaUnitKey"
      buttonText="打开"
    />
  </div>
</template>
<script>
import ReportCard from './components/ReportCard.vue'
import CollapseKnowledge from './components/CollapseKnowledge.vue'
import AnswerSheet from './components/AnswerSheet.vue'
import FooterOpenApp from '@/components/FooterOpenApp.vue'
import { getEstimateReportApi } from '@/api/estimate'
import ReportLineChart from './components/ReportLineChart.vue'
export default {
  components: { ReportCard, CollapseKnowledge, AnswerSheet, FooterOpenApp, ReportLineChart },
  data() {
    return {
      info: null,
      distribution_map: null,
      paper_info: null,
      point: null,
      rec_job_info: null,
      record: null,
      volunt_record: [], //多岗位估分情况

      answerSheetData: [], //答题卡数据

      schemaUnitKey: 'EstimateScoreDetail',

      tabNavIndex: 0,
    }
  },
  mounted() {
    this.getEstimateReport()
  },
  computed: {
    secondText() {
      return function (number) {
        let second = number % 60
        let minute = (number - second) / 60
        second = this.$util.formatSingleNumber(second) + '″'
        minute = this.$util.formatSingleNumber(minute) + '′'

        return minute + second
      }
    },
  },

  methods: {
    // 获取估分报告数据
    getEstimateReport() {
      let params = this.routeFixedParam()
      params.id = this.$route.query.id
      console.log(params)
      getEstimateReportApi(params).then((res) => {
        const resData = res.data
        this.info = resData.info || null
        this.distribution_map = resData.distribution_map || null
        this.paper_info = resData.paper_info || null
        this.point = resData.point || null
        this.rec_job_info = resData.rec_job_info || null
        this.volunt_record = resData.volunt_record || []
        let record = resData.record || {}

        this.answerSheetData = this.formatAnswerSheetData(
          record.group_data,
          record.index,
          record.exam_record?.answer
        )

        if (resData.user_info?.nickname) {
          document.title = resData.user_info.nickname + '的估分报告'
        }
        // 设置分享标题
        this.$util.setShare({
          title: resData.paper_info.name,
          desc: `快来看看我的估分报告，一起对答案吧！`,
          link: window.location.href,
          imgUrl:
            'https://training-1253756937.cos.ap-chengdu.myqcloud.com/commonImage/Admin/estimate_item/image/2024-3-15/44365645878.png' ||
            '',
        })

        this.$nextTick(() => {
          this.$refs.footer_open_app.updateConfig(this.info.item_id)
          console.log(window?.tikuWeb?.setShareHtml,'2222')
          if(window?.tikuWeb?.setShareHtml) {
            console.log('111')
            const headHtml = document.getElementsByTagName('head')[0].innerHTML;
            const fullHeadHtml = `<head>${headHtml}</head>`;
            window.tikuWeb.setShareHtml(fullHeadHtml);
          }
        })
      })
    },
    // 格式化答题卡数据
    formatAnswerSheetData(groupArray = [], groupIndexArray = [], answer = {}) {
      let result = new Array(groupIndexArray.length).fill({})
      let countIndex = 0
      result = result.map((item, index) => {
        const title = groupArray[index]?.title || ''
        let list = groupIndexArray[index] || []
        list = list.map((questionId) => {
          let r = answer[questionId]?.r || 0
          countIndex++
          return { id: questionId, r: parseInt(r), countIndex }
        })
        return { title, list }
      })
      console.log(result)
      return result
    },
  },
}
</script>
<style lang="scss" scoped>
.report-infor {
  &-tips {
    font-size: 0.32rem;
    font-weight: 400;
    color: #919499;
    opacity: 0.5;
    text-align: right;
  }

  &-score {
    text-align: center;
    margin-bottom: 0.43rem;

    .my-score {
      .number {
        font-size: 1.33rem;
        font-family: DIN;
        font-weight: bold;
        color: var(--main-color);
        opacity: 0.94;
      }

      .text {
        font-size: 0.37rem;
        font-weight: 600;
        line-height: 0.56rem;
        color: var(--main-color);
      }
    }

    .total-score {
      font-size: 0.32rem;
      font-weight: 400;
      line-height: 0.56rem;
      color: #666666;
      opacity: 0.5;
    }
  }

  &-ranking {
    background: rgba($color: #f7f8fa, $alpha: 0.6);
    border-radius: 0.16rem;
    padding-top: 0.43rem;
    padding-bottom: 0.53rem;
    margin-bottom: 0.53rem;

    .ranking-title {
      @include flex_center;
      margin-bottom: 0.8rem;

      .title-icon {
        width: 1.49rem;
        margin-right: 0.05rem;
      }

      .ranking-text {
        @include flex_center;
        font-size: 0.32rem;
        margin: 0 0.32rem;

        .trophy-icon {
          width: 0.37rem;
          margin-right: 0.05rem;
        }

        .text {
          color: #3c3d42;
        }

        .text2 {
          font-size: 0.37rem;
          font-family: DIN;
          font-weight: 500;
          color: #666666;
          opacity: 0.5;
        }
      }
    }

    .ranking-score {
      display: flex;

      &-item {
        position: relative;
        flex: 1;
        text-align: center;

        &:nth-child(n + 2) {
          &::before {
            @include position_centerY;
            left: 0;
            content: '';
            width: 0.03rem;
            height: 0.85rem;
            background: #f5f6f8;
          }
        }

        .number {
          font-size: 0.48rem;
          font-family: DIN;
          font-weight: 500;
          color: #3c3d42;
          margin-bottom: 0.13rem;

          &--beat {
            color: #ff7e56;
          }
        }

        .text {
          font-size: 0.32rem;
          font-weight: 500;
          line-height: 0.61rem;
          color: #666666;
        }
      }
    }
  }

  &-questionset {
    .van-cell {
      padding: 0;
      line-height: 0.43rem;
      font-size: 0.29rem;

      &:nth-child(n + 2) {
        margin-top: 0.16rem;
      }

      &__title {
        max-width: 1.6rem;
        opacity: 0.5;
        color: #666666;
      }

      &__value {
        color: #666666;
        font-size: 0.29rem;
        text-align: left;
      }
    }
  }
}

.report-job-list {
  margin-top: 0.43rem;

  .van-cell {
    padding: 0;
    line-height: 0.56rem;

    &:nth-child(n + 2) {
      margin-top: 0.1rem;
    }

    &__title {
      font-size: 0.35rem;
      font-weight: 400;
      color: #919499;
    }

    &__value {
      font-size: 0.35rem;
      color: #3c3d42;
    }
  }

  .my-job-value {
    color: #919499;
  }
}

.report-answer-infor {
  margin-top: 0.43rem;

  .answer-summary {
    display: flex;
    background: rgba($color: #f7f8fa, $alpha: 0.6);
    border-radius: 0.16rem;

    .summary-item {
      flex: 1;
      text-align: center;
      position: relative;
      padding-top: 0.27rem;
      padding-bottom: 0.27rem;

      &:nth-child(n + 2):before {
        @include position_centerY;
        content: '';
        left: 0;
        width: 0.01rem;
        height: 0.43rem;
        background-color: #eee;
      }

      .name {
        font-size: 0.29rem;
        font-weight: 400;
        line-height: 0.6rem;
        color: #919499;
        opacity: 0.7;
      }

      .text {
        font-size: 0.27rem;
        font-weight: 400;
        color: #3c3d42;

        &--error {
          color: #ff6a4d;
        }

        &--empty {
          color: #919499;
        }

        .font-number {
          font-size: 0.35rem;
        }
      }
    }
  }
}

.container-wrapper {
  padding-bottom: 1.7rem;
  min-height: 100vh;
  background: #f7f8fa;
  box-sizing: border-box;
  background-size: 100%;
  background-position: top;
  background-repeat: no-repeat;
  padding-top: 1.17rem;

  .container {
    padding-left: 0.43rem;
    padding-right: 0.43rem;
  }
}

.tab-nav {
  display: flex;
  margin-top: 0.43rem;

  &-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.81rem;
    height: 0.64rem;
    background: #f7f8fa;
    border-radius: 0.11rem;
    border: 1px solid #f7f8fa;
    color: #666666;
    font-size: 0.29rem;
    margin-right: 0.16rem;

    &.active {
      background-color: rgba($color: var(--main-rgba), $alpha: 0.05);
      color: var(--main-color);
      border-color: var(--main-color);
    }
  }
}
</style>
